import { render, staticRenderFns } from "./EditUserPasswordField.vue?vue&type=template&id=4e5ba348&scoped=true"
import script from "./EditUserPasswordField.vue?vue&type=script&lang=js"
export * from "./EditUserPasswordField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ba348",
  null
  
)

export default component.exports